import { writable } from "svelte/store";

export const listUpdateTriggered = writable(false);
export const triggerListUpdate = () => {
    listUpdateTriggered.update((value) => !value);
};

export const isImporting = writable(false);
